import Layout from '../components/Layout'
import { PageHeader, Section, Card, StatCard } from '../components/UIComponents'

export default function Earn() {
  return (
    <Layout>
      <div className="space-y-8 max-w-6xl mx-auto">
        <PageHeader
          icon="💰"
          title="Ganar"
          description="Múltiples formas de ganar rewards en OTD"
        />

        <Section title="Tu Earnings">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <StatCard
              icon="💸"
              label="Earnings Totales"
              value="$0.00"
              change="0%"
              changeType="up"
            />
            <StatCard
              icon="📊"
              label="Este Mes"
              value="$0.00"
              change="0"
              changeType="down"
            />
            <StatCard
              icon="🎯"
              label="Pendiente"
              value="$0.00"
              change="0"
              changeType="up"
            />
          </div>
        </Section>

        <Section title="Oportunidades de Earning">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { title: 'Referrals', desc: 'Gana por cada referido', earn: '+10%' },
              { title: 'Tasks', desc: 'Completa tareas diarias', earn: '+$5' },
              { title: 'Staking', desc: 'Bloquea activos', earn: '+7% APY' },
              { title: 'Rewards', desc: 'Gana por actividad', earn: '+pts' },
            ].map((item, i) => (
              <Card key={i} className="hover:bg-slate-800/50">
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <h3 className="text-white font-semibold">{item.title}</h3>
                    <span className="text-green-400 font-bold">{item.earn}</span>
                  </div>
                  <p className="text-slate-400 text-sm">{item.desc}</p>
                </div>
              </Card>
            ))}
          </div>
        </Section>
      </div>
    </Layout>
  )
}
